const OpeningBalanceActionTypes = {
	/** ***************** GET OPENING BALANCE START *********************** */
	GET_OPENING_BALANCE_DETAILS_START: 'add_opening_balance_details_start',
	GET_OPENING_BALANCE_DETAILS_SUCCESS: 'add_opening_balance_details_success',
	GET_OPENING_BALANCE_DETAILS_FAILURE: 'add_opening_balance_details_failure',
	GET_OPENING_BALANCE_DETAILS_RESPONSE_RESET: 'add_opening_balance_details_response_reset',
	GET_OPENING_BALANCE_DETAILS_RESPONSE_CHANGED: 'add_opening_balance_details_response_changed',
	/** ***************** GET OPENING BALANCE END *********************** */

	/** ***************** UPDATE OPENING BALANCE START *********************** */
	UPDATE_OPENING_BALANCE_DETAILS_START: 'update_opening_balance_details_start',
	UPDATE_OPENING_BALANCE_DETAILS_SUCCESS: 'update_opening_balance_details_success',
	UPDATE_OPENING_BALANCE_DETAILS_FAILURE: 'update_opening_balance_details_failure',
	UPDATE_OPENING_BALANCE_DETAILS_RESPONSE_RESET: 'update_opening_balance_details_response_reset',
	UPDATE_OPENING_BALANCE_DETAILS_RESPONSE_CHANGED:
		'update_opening_balance_details_response_changed',
	/** ***************** UPDATE OPENING BALANCE END *********************** */
};
export default OpeningBalanceActionTypes;
